﻿'use strict';
import { TweenLite, gsap, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];

import Axios from "axios";

export default class PartnersListing {

    constructor() {

        if (!d.querySelector("#localMarketPartners.partners") ) {
            return;
        }

        const allClasses = d.querySelectorAll(".org-card");

        let cityOptions = [];



        const applyFilter = (suppressAnimation) => {


            const currentUrl = window.location.href;
            applyPaging("1", currentUrl);
            //let filterListing = [];
            //let activeFilterItems = d.querySelectorAll(`.org-card`);

            //allClasses.forEach((card) => {
            //    card.style.visibility = "";
            //    card.style.opacity = "";
            //    card.style.display = "";
            //});



            const city = d.querySelector("#cityOption li.sel").dataset.value;
           
    
            //let cityQuery = "";
            //let activityNotQuery = "";
  
            document.querySelector("#paging").style.display = "block";
           
            if (city) {

                document.querySelector("#paging").style.display = "none";
                //activityNotQuery = `:not([data-city='${city}'])`;
                //cityQuery = `[data-city='${city}']`;
            }

            //activeFilterItems = d.querySelectorAll(`.org-card${cityQuery}`);

            //cityOptions = d.querySelectorAll(`.org-card${cityQuery}`);


            //allClasses.forEach((card) => {
            //    let found = false;

            //    activeFilterItems.forEach((activeCard) => {
            //        if (card == activeCard) {
            //            found = true;
            //        }
            //    });
            //    if (!found) {
            //        filterListing.push(card);
            //    }

            //});


            //if (activeFilterItems) {

            //    var fuse = suppressAnimation ? 0 : .25;
            //    var secondFuse = suppressAnimation ? 0 : .5;
            //    //console.log("allClasses:: ", allClasses);
            //    TweenLite.to(allClasses, fuse, {
            //        opacity: 0, onComplete: () => {

            //            filterListing.forEach((item, i) => {

            //                item.style.display = "none";
            //            });


            //            allClasses.forEach((item, i) => {

            //                TweenLite.to(item, secondFuse, {
            //                    opacity: 1,
            //                    delay: i * .05,
                     
            //                    onComplete: () => {
                                   
            //                    }
            //                });

            //            });
            //        }
            //    });
            //}

            ///*APPLY DROPDOWN STATISTICS*/
            //let activeCities = [""];
            //cityOptions.forEach((card) => {


            //    const _city = card.dataset.city;

            //    if (activeCities.indexOf(_city) < 0) {
            //        activeCities.push(_city);
            //    }
            //});



        };


        const applyPaging = (page, url) => {
            TweenLite.to(window, .5, {
                scrollTo: { y: "#cityOption", offsetY: 20 }
            });

            let allClasses = d.querySelectorAll(".org-card");

            allClasses.forEach((card) => {
                TweenLite.to(card, .25, { opacity: 0 });
            });

            Axios.get(url).then((result) => {

                if (result.data != null) {
                    var newPage = document.createElement("html");

                    newPage.innerHTML = result.data;
                    document.querySelector(".partner-grid").innerHTML = newPage.querySelector(".partner-grid").innerHTML;

                    allClasses = d.querySelectorAll(".org-card");
                    allClasses.forEach((card) => {

                        card.style.opacity = "0";
                        card.style.display = "";
                    });


                    allClasses.forEach((card, i) => {
                        TweenLite.to(card, .5, { autoAlpha: 1, delay: i * .05 });
                    });

                    document.querySelector("#paging a.active").classList.remove("active");
                    document.querySelector(`#paging a[data-page="${page}"]`).classList.add("active");
                }
            });

        }

        if (d.querySelector("#paging")) {

   
            gsap.registerPlugin(ScrollToPlugin);
            document.querySelectorAll("#paging a").forEach((link) => {

                link.addEventListener("click", (e) => {
                    const state = { page: e.currentTarget.innerText };
                    history.pushState(state, "", e.currentTarget.getAttribute("href"));

                    applyPaging(e.currentTarget.innerText, e.currentTarget.getAttribute("href"));


                    e.preventDefault();
                    return false;
                });

            });
        }

        if (d.querySelector("#cityOption")) {


            d.querySelector("#cityOption").addEventListener("change", (e) => {
                const value = e.detail.dataset.value;


                const state = { city: value };
                history.pushState(state, "", `/community/partners/${value}`);

                applyFilter();
            });

         //   applyFilter(true);
        }


        window.addEventListener("popstate", (event) => {
            if (event.state && event.state.city) {
                d.querySelector(`#cityOption li[data-value='${event.state.city}']`).dispatchEvent(new Event('click'));

            } else if (event.state && event.state.page) {
                const currentUrl = window.location.href;
                applyPaging(event.state.page, currentUrl);
            } else {
                //d.querySelector(`#cityOption li[data-value='']`).dispatchEvent(new Event('click'));

                applyPaging("1", "/community/partners");
            }

        });
        window.addEventListener("pushState", (event) => {
            if (event.state && event.state.page) {
                const currentUrl = window.location.href;
                applyPaging(event.state.page, currentUrl);
            }
        });
    }
}